import { IProfileProResponse } from '../..';
import { i18n } from '../../i18n-handler/handler/i18n';
import { IPermission } from '../interfaces/IPermission';

let lang = 'fr';

export function autoValidateExtrasMission(profile: IProfileProResponse): IPermission {
    const can = (profile.user.data.can_sepa && profile.user.data.has_mandate) || profile.user.data.can_bankwire;
    return {
        can,
    };
}

export function createMission(profile: IProfileProResponse): { can: boolean } {
    const can = profile.user.validationStep === 0;
    return {
        can,
    };
}

export function keepConfirmedExtrasForDuplication(profile: IProfileProResponse): { message: string; can: boolean } {
    const can = profile.user.data.can_sepa || profile.user.data.can_bankwire;
    return {
        can,
        message:
            can === true ? '' : `${i18n.t('permissions.pro-keep-confirmed-extras-for-duplication', { lng: lang })}`,
    };
}

export function viewIBAN(profile: IProfileProResponse): { message: string; can: boolean } {
    const can = profile.user.validationStep == 0 || profile.user.validationStep > 1;
    return {
        can,
        message: can === true ? '' : `${i18n.t('permissions.pro-view-iban', { lng: lang })}`,
    };
}

export function viewInvoices(profile: IProfileProResponse): IPermission {
    const can =
        (profile.user.validationStep === 0 && profile.user.data.confirmed === true) ||
        profile.user.data.blocked === true;
    return {
        can,
    };
}

export function viewMissions(profile: IProfileProResponse): IPermission {
    const can = profile.user.validationStep === 0 && profile.user.data.confirmed === true;
    return {
        can,
    };
}

export function viewNotifications(profile: IProfileProResponse): IPermission {
    const can = profile.user.validationStep === 0 && profile.user.data.confirmed === true;
    return {
        can,
    };
}

export function viewPayment(profile: IProfileProResponse): IPermission {
    const can = profile.user.validationStep === 0 || profile.user.validationStep > 1;
    return {
        can,
    };
}

export function viewProfileCompletion(validationStep: number): { can: boolean } {
    const can = validationStep > 0;
    return {
        can,
    };
}

export function viewRatings(profile: IProfileProResponse): IPermission {
    const can = profile.user.validationStep === 0 && profile.user.data.confirmed === true;
    return {
        can,
    };
}

export type ProPermissionsReturn = {
    autoValidateExtrasMission: Function;
    createMission: Function;
    viewIBAN: Function;
    viewProfileCompletion: Function;
    keepConfirmedExtrasForDuplication: Function;
    viewMissions: Function;
    viewRatings: Function;
    viewInvoices: Function;
    viewPayment: Function;
    viewNotifications: Function;
};

export const proPermissions = (_lang: string): ProPermissionsReturn => {
    lang = _lang;

    return {
        autoValidateExtrasMission,
        createMission,
        viewIBAN,
        viewProfileCompletion,
        keepConfirmedExtrasForDuplication,
        viewMissions,
        viewRatings,
        viewInvoices,
        viewPayment,
        viewNotifications,
    };
};
